import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { AuthGuard } from './components/AuthGuard';
import { NavigationShell } from './components/NavigationShell';
import { DashboardView } from './views/DashboardView';
import { InventoryTable } from './views/InventoryTable';
import { ResourceDetail } from './views/ResourceDetail';
import { SecurityDashboard } from './views/SecurityDashboard';
import { FindingDetail } from './views/FindingDetail';
import { RelationshipGraph } from './views/RelationshipGraph';
import './index.css';

const MetricsDashboardV2Layout = React.lazy(() => import('./views/metrics-v2/MetricsDashboardV2Layout'));

const router = createBrowserRouter([
  {
    path: '/',
    element: <NavigationShell />,
    children: [
      { index: true, element: <DashboardView /> },
      { path: 'inventory', element: <InventoryTable /> },
      { path: 'inventory/:id', element: <ResourceDetail /> },
      { path: 'security', element: <SecurityDashboard /> },
      { path: 'security/findings/:id', element: <FindingDetail /> },
      { path: 'metrics', element: <Suspense fallback={<div>Cargando...</div>}><MetricsDashboardV2Layout /></Suspense> },
      { path: 'relationships', element: <RelationshipGraph /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthGuard>
      <RouterProvider router={router} />
    </AuthGuard>
  </React.StrictMode>,
);
